module.exports = __webpack_public_path__ + "img/comment.32da96c7.jpg";